import React, { useEffect, useState } from "react";
import { CRMLayout } from "@/components/CRMLayout";
import { api } from "@/lib/api";
import { Plus, X, FileText } from "lucide-react";

const Documents = () => {
  const [docs, setDocs] = useState([]);
  const [open, setOpen] = useState(false);
  const [form, setForm] = useState({ name: "", type: "contract", url: "", deal_id: "", notes: "" });
  const load = () => api.get("/crm/documents").then((r) => setDocs(r.data)).catch(() => {});
  useEffect(() => { load(); }, []); // eslint-disable-line
  const create = async (e) => {
    e.preventDefault();
    await api.post("/crm/documents", form);
    setOpen(false);
    setForm({ name: "", type: "contract", url: "", deal_id: "", notes: "" });
    load();
  };
  const del = async (id) => {
    if (!window.confirm("Delete document?")) return;
    await api.delete(`/crm/documents/${id}`);
    load();
  };
  return (
    <CRMLayout>
      <div className="flex items-end justify-between mb-6" data-testid="crm-documents-page">
        <div>
          <div className="overline text-gold">Files</div>
          <h1 className="font-display text-3xl text-navy mt-2">Documents</h1>
        </div>
        <button onClick={() => setOpen(true)} className="btn-navy text-sm py-2.5 px-4" data-testid="doc-add-btn"><Plus className="w-4 h-4" /> Add Document</button>
      </div>

      <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-4">
        {docs.map((d) => (
          <div key={d.id} className="bg-white border border-slate-200 p-5" data-testid={`doc-${d.id}`}>
            <div className="flex items-start justify-between">
              <div className="flex items-center gap-3">
                <FileText className="w-6 h-6 text-gold" strokeWidth={1.5} />
                <div>
                  <div className="font-semibold text-navy">{d.name}</div>
                  <div className="text-xs text-slate-500 uppercase tracking-wider mt-0.5">{d.type}</div>
                </div>
              </div>
              <button onClick={() => del(d.id)} className="text-xs text-red-500" data-testid={`doc-delete-${d.id}`}>Delete</button>
            </div>
            {d.notes && <p className="text-sm text-slate-600 mt-3">{d.notes}</p>}
            {d.url && <a href={d.url} target="_blank" rel="noreferrer" className="text-xs text-gold mt-3 inline-block hover:text-gold-dark">Open document →</a>}
          </div>
        ))}
        {docs.length === 0 && <div className="text-slate-500 p-6">No documents added yet.</div>}
      </div>

      {open && (
        <div className="fixed inset-0 bg-navy/70 z-50 flex items-center justify-center p-4" onClick={() => setOpen(false)}>
          <div className="bg-white w-full max-w-lg p-8 relative" onClick={(e) => e.stopPropagation()}>
            <button onClick={() => setOpen(false)} className="absolute top-4 right-4 text-slate-400" data-testid="doc-modal-close"><X className="w-5 h-5" /></button>
            <h2 className="font-display text-2xl text-navy mb-6">Add Document</h2>
            <form onSubmit={create} className="space-y-3" data-testid="doc-form">
              <input required placeholder="Document name" value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} className="w-full border border-slate-200 px-3 py-2.5 text-sm" data-testid="doc-form-name" />
              <select value={form.type} onChange={(e) => setForm({ ...form, type: e.target.value })} className="w-full border border-slate-200 px-3 py-2.5 text-sm bg-white" data-testid="doc-form-type">
                <option value="contract">Contract</option><option value="nda">NDA</option><option value="agreement">Agreement</option><option value="financial">Financial</option><option value="other">Other</option>
              </select>
              <input placeholder="External URL (Drive, Dropbox, etc.)" value={form.url} onChange={(e) => setForm({ ...form, url: e.target.value })} className="w-full border border-slate-200 px-3 py-2.5 text-sm" data-testid="doc-form-url" />
              <textarea rows="3" placeholder="Notes" value={form.notes} onChange={(e) => setForm({ ...form, notes: e.target.value })} className="w-full border border-slate-200 px-3 py-2.5 text-sm" data-testid="doc-form-notes" />
              <button className="btn-navy w-full" data-testid="doc-form-submit">Add Document</button>
            </form>
          </div>
        </div>
      )}
    </CRMLayout>
  );
};

export default Documents;
